import { createStore } from 'vuex'
import getters from '@/store/getters'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import categories from './modules/categories'
import documentsLs from './modules/documents-ls'
import documentTypes from './modules/documentTypes'
import external from './modules/external'
import identifiers from './modules/identifiers'
import requests from './modules/requests'
import users from './modules/users'
import organizations from './modules/organizations'
import invoices from './modules/invoices'
import events from './modules/events'
import verifications from './modules/verifications'
import auth from './modules/auth'
import authorization from './modules/authorization'
import notifications from './modules/notifications'

export default createStore({
  modules: {
    categories,
    documentsLs,
    documentTypes,
    identifiers,
    requests,
    users,
    organizations,
    invoices,
    events,
    verifications,
    auth,
    authorization,
    notifications,
    external
  },
  state: {
    unsubscribes: []
  },
  getters,
  actions,
  mutations
})
